import type { CascaderComponentTypes } from '@frontend/legacy-components';

import type { MaterialCascaderSuggestionOption } from './materialCascaderSuggestionTypes';
import {
  MaterialSuggestionControl,
  MaterialSuggestionDropdownIndicator,
  MaterialSuggestionIndicatorSeparator,
  MaterialSuggestionInput,
  MaterialSuggestionPlaceholder,
  MaterialSuggestionSelectedValueContainer,
  MaterialSuggestionSingleSelectedValue,
} from './materialSuggestionCascaderChrome';
import {
  MaterialSuggestionLeafOption,
  MaterialSuggestionSearchOption,
  MaterialSuggestionSubmenuOption,
} from './materialSuggestionCascaderMenuOptions';

/**
 * Cascader `components` map for material library + overview-bundle field suggestions.
 * Colocated with {@link MaterialSelector} so menu/field behavior stays out of the design-system package.
 */
export const materialSuggestionCascaderComponents: Partial<
  CascaderComponentTypes<MaterialCascaderSuggestionOption>
> = {
  LeafOption: MaterialSuggestionLeafOption,
  SearchOption: MaterialSuggestionSearchOption,
  SubmenuOption: MaterialSuggestionSubmenuOption,
  Control: MaterialSuggestionControl,
  DropdownIndicator: MaterialSuggestionDropdownIndicator,
  IndicatorSeparator: MaterialSuggestionIndicatorSeparator,
  SelectedValueContainer: MaterialSuggestionSelectedValueContainer,
  Input: MaterialSuggestionInput,
  Placeholder: MaterialSuggestionPlaceholder,
  SingleSelectedValue: MaterialSuggestionSingleSelectedValue,
};
